var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 6.39941L14.001 4.40066L15.9998 3.39941L14.001 2.39816L12.9998 0.399414L11.9985 2.39816L9.99977 3.39941L11.9985 4.40066L12.9998 6.39941ZM18.3997 7.59941L17.7998 6.39941L17.1998 7.59941L15.9998 8.19941L17.1998 8.79941L17.7998 9.99941L18.3997 8.79941L19.5997 8.19941L18.3997 7.59941ZM14.061 10.4232L10.131 9.84941L8.37227 6.27941C8.05727 5.64191 7.14602 5.63441 6.82727 6.27941L5.06852 9.84941L1.13853 10.4232C0.433533 10.5244 0.148534 11.3944 0.662283 11.8932L3.50853 14.6682L2.83353 18.5907C2.71353 19.2994 3.45978 19.8319 4.08228 19.4982L7.59977 17.6457L11.1173 19.4982C11.7435 19.8282 12.486 19.2994 12.366 18.5907L11.6948 14.6682L14.541 11.8932C15.051 11.3944 14.766 10.5244 14.061 10.4232Z",
    fill: "#6A5DF9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.13d625e0d9a03e83ade711b8c09f067e.svg";
export { ForwardRef as ReactComponent };